<template>
  <div class="bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 py-12" v-if="salon">
    <div class="grid md:grid-cols-3 gap-10">
      <!-- Colonne principale (2/3) -->
      <div class="md:col-span-2 space-y-10">
        <!-- Image principale -->
        <img
          :src="salon.logo"
          alt="Image du salon"
          class="w-full h-80 object-cover rounded-3xl shadow-xl hover:scale-[1.02] transition-transform duration-300"
        />
<!-- Prestations -->
<section>
  <h2 class="text-2xl font-bold text-gray-900 mb-6 border-b pb-2">Soins et services vétérinaires</h2>
  
  <div v-for="(cat, index) in salon.categories" :key="cat._id" class="mb-6 border-b pb-4">
    <div 
      @click="toggleCategorie(index)" 
      class="flex justify-between items-center cursor-pointer group"
    >
      <h3 class="text-xl font-semibold text-[#18b7bd] pl-2 border-l-4 border-[#18b7bd]">
        {{ cat.nom }}
      </h3>
      <svg 
        :class="{'rotate-180': openedCategorie === index}" 
        class="w-5 h-5 text-[#18b7bd] transform transition-transform duration-300"
        fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>

    <transition name="fade">
      <div v-if="openedCategorie === index" class="mt-4 space-y-4">
        <div 
          v-if="cat.services && cat.services.length"
        >
      <div
  v-for="(service) in cat.services"
  :key="service._id"
  class="p-4 rounded-xl transition mb-4"
>
  <!-- Ligne principale -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
    <div class="text-lg font-semibold text-gray-900 break-words">
      {{ service.nom }}
    </div>
    <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6 mt-2 sm:mt-0">
      <div class="text-[#18b7bd] font-medium whitespace-nowrap">
        {{ service.prix }} €
      </div>
      <div class="text-gray-500 whitespace-nowrap">
        {{ service.duree }} min
      </div>
      <button
        @click="prendreRdv(service)"
        class="bg-[#18b7bd] text-white rounded-md px-4 py-2 font-semibold hover:bg-[#18b7bd] transition whitespace-nowrap"
      >
        Prendre rendez-vous
      </button>
    </div>
  </div>
  <!-- Description -->
  <p class="text-sm text-gray-600 mt-2 text-left">
    {{ service.description }}
  </p>
</div>

        </div>
        <div v-else class="text-gray-500 italic mt-2">Aucune prestation dans cette catégorie.</div>
      </div>
    </transition>
  </div>
</section>



        <!-- Portfolio -->
        <section v-if="salon.photos.length > 1">
          <h2 class="text-2xl font-bold text-gray-900 mb-6 border-b pb-2">Galerie de la clinique</h2>
          <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            <img
              v-for="(photo, idx) in salon.photos"
              :key="idx"
              :src="photo"
              alt="Portfolio photo"
              class="rounded-lg object-cover h-40 w-full shadow-md hover:scale-105 transition-transform cursor-pointer"
              @click="ouvrirPhoto(photo)"
            />
          </div>
        </section>

   <div class="text-center max-w-3xl mx-auto">
    <h1 class="text-2xl font-bold text-gray-900 mb-6 border-b pb-2">
     notre équipe
    </h1>
   </div>
<section class="mt-14 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
  <article
    v-for="admin in salon?.administrateurs"
    :key="admin._id"
    class="rounded-2xl overflow-hidden shadow-lg relative"
  >
    <!-- Si photo présente -->
    <img
      v-if="admin.photo"
      :src="admin.photo"
      class="w-full h-[200px] object-cover"
      :alt="`Photo de ${admin.prenom} ${admin.nom}`"
      width="600"
      height="200"
    />

    <!-- Si pas de photo, on affiche les initiales -->
    <div
      v-else
      class="w-full h-[200px] bg-gray-200 flex items-center justify-center text-4xl font-bold text-gray-700"
    >
      {{ getInitiales(admin.prenom, admin.nom) }}
    </div>

    <div class="absolute bottom-4 left-4 right-4 bg-white bg-opacity-90 rounded-xl p-4 shadow-md">
      <p class="font-semibold text-black text-base mb-1">
        {{ admin.prenom }} {{ admin.nom }}
      </p>
    </div>
  </article>
</section>


      </div>

      <!-- Colonne secondaire (1/3) -->
      <div class="space-y-6">
        <h1 class="text-4xl font-bold text-gray-900">{{ salon.nom_societe }}</h1>
        <p class="text-gray-600 text-base">{{ salon.description }}</p>

       

        <!-- Horaires -->
        <div class="bg-white rounded-xl shadow p-4">
          <h2 class="text-base font-semibold text-black mb-3">Horaires d'ouverture</h2>
          <div class="space-y-2">
            <div
              v-for="(creneaux, jour) in salon.horaires"
              :key="jour"
              class="flex justify-between border-b border-gray-100 pb-1"
            >
              <span class="capitalize text-gray-600">{{ jour }}</span>
              <span v-if="creneaux.length > 0" class="font-medium text-black">
                {{ creneaux.map(c => `${c.debut} - ${c.fin}`).join(', ') }}
              </span>
              <span v-else class="text-gray-400 italic">Fermé</span>
            </div>
          </div>
        </div>

       <!-- Adresse -->
<div class="bg-white rounded-xl shadow p-4 flex flex-col gap-4">
  <div class="flex items-start gap-4">
    <i class="fas fa-map-marker-alt text-[#18b7bd] text-xl mt-1"></i>
    <div class="text-gray-800 text-sm">
      <p class="font-medium">Adresse</p>
      <p class="text-gray-600">{{ salon.adresse }}</p>
    </div>
  </div>

  <!-- Google Maps -->
  <iframe
    class="w-full h-64 rounded-xl shadow-md border"
    :src="`https://www.google.com/maps?q=${encodeURIComponent(salon.adresse)}&output=embed`"
    frameborder="0"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
  ></iframe>
</div>


<!-- Avis -->
<div class="bg-white rounded-xl shadow p-4">
  <div class="flex border-b border-gray-200">
    <button
      @click="switchTab('global')"
      :class="[
        'flex-1 py-3 text-base font-normal',
        activeTab === 'global' ? 'text-black border-b-2 border-black' : 'text-gray-500'
      ]"
      type="button"
    >
      Note globale
    </button>
    <button
      @click="switchTab('avis')"
      :class="[
        'flex-1 py-3 text-base font-normal',
        activeTab === 'avis' ? 'text-black border-b-2 border-black' : 'text-gray-500'
      ]"
      type="button"
    >
      Avis
    </button>
  </div>

  <div class="mt-4 min-h-[120px]">
    <template v-if="activeTab === 'global'">
      <div class="flex rounded-lg border border-gray-300 overflow-hidden">
        <div class="bg-gray-900 flex items-center justify-center px-6 py-4 min-w-[80px]">
          <span class="text-white font-extrabold text-3xl leading-none">
            {{ noteGenerale !== null ? noteGenerale.toFixed(1) : '–' }}
          </span>
        </div>
        <div class="flex-1 bg-gray-100 p-4 text-gray-600 text-base leading-relaxed space-y-2 rounded-r-lg">
          <p>Note établissement <span class="font-semibold text-black ml-1">{{ noteEtablissement !== null ? noteEtablissement.toFixed(1) : '–' }}</span> <i class="fas fa-star text-black ml-1"></i></p>
          <p>Note Soins <span class="font-semibold text-black ml-1">{{ notePrestations !== null ? notePrestations.toFixed(1) : '–' }}</span> <i class="fas fa-star text-black ml-1"></i></p>
          <p>Note Vétérinaire <span class="font-semibold text-black ml-1">{{ noteEmploye !== null ? noteEmploye.toFixed(1) : '–' }}</span> <i class="fas fa-star text-black ml-1"></i></p>
          <p class="pt-2 text-black font-normal">{{ nombreAvis }} client{{ nombreAvis > 1 ? 's' : '' }} ont donné leur avis</p>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="max-h-[300px] overflow-y-auto space-y-4">
        <div
          v-for="avis in avisList"
          :key="avis._id"
          class="p-4 border border-gray-200 rounded-lg bg-gray-50"
        >
          <p class="text-gray-800 italic">"{{ avis.avis }}"</p>
          <p class="mt-2 text-sm text-gray-600">
            <span class="font-semibold">{{ avis.clientId.prenom }} {{ avis.clientId.nom }}</span> -
            Note établissement: {{ avis.noteEtablissement }} ⭐,
            Note Services vétérinaires: {{ avis.notePrestations }} ⭐,
            Note de l’équipe: {{ avis.noteEmploye }} ⭐
          </p>
          <p class="text-xs text-gray-400 mt-1">{{ new Date(avis.dateAvis).toLocaleDateString() }}</p>
        </div>
        <p v-if="avisList.length === 0" class="text-center text-gray-500">Aucun avis disponible.</p>
      </div>
    </template>
  </div>
</div>


        <!-- Bouton principal -->
        <button
          class="w-full bg-[#18b7bd] hover:bg-[#18b7bd] text-white font-semibold px-6 py-3 rounded-lg shadow transition duration-200"
          @click="redirigerVersRdv()"
        >
          Prendre rendez-vous pour mon animal
        </button>
      </div>
    </div>
   

  </div>
  </div>

</template>


<script>
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'

export default {
  data() {
    return {
      salon: null,
      avisList: [],
      noteEtablissement: null,
      notePrestations: null,
      noteEmploye: null,
      noteGenerale: null,
      nombreAvis: 0,
      activeTab: 'global',
      salonId: null, 
      openedCategorie: null
    }
  },
  created() {
    const route = useRoute()
    this.router = useRouter()
    this.salonId = route.params.id
  },
  async mounted() {
    try {
      // Charger les données salon
      const { data: salonData } = await axios.get(`https://b53c7d5edf32.ngrok-free.app/api/search/${this.salonId}`)
      this.salon = salonData
      console.log(this.salon)

      // Charger les avis et moyennes
      const { data: avisData } = await axios.get(`https://b53c7d5edf32.ngrok-free.app/api/avis/${this.salonId}`)

      if (avisData.success && avisData.moyennes) {
        this.noteEtablissement = avisData.moyennes.noteEtablissement
        this.notePrestations = avisData.moyennes.notePrestations
        this.noteEmploye = avisData.moyennes.noteEmploye
        this.noteGenerale = avisData.moyennes.noteGenerale
        this.avisList = avisData.avis
        this.nombreAvis = this.avisList.length
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('adminToken')
        this.router.push('/login')
      }
      console.error('Erreur lors du chargement du salon ou des avis :', error)
    }
  },
  methods: {
     toggleCategorie(index) {
    this.openedCategorie = this.openedCategorie === index ? null : index;
  },
    switchTab(tab) {
      this.activeTab = tab
    },
    redirigerVersRdv() {
      this.router.push(`/rendez-vous/${this.salonId}`)
    },
    prendreRdv(service) {
      this.router.push({
        path: `/rendez-vous/${this.salonId}`,
        query: { service: service._id }
      })
    },
    ouvrirPhoto(photoUrl) {
      window.open(photoUrl, '_blank')
    },
    getInitiales(prenom, nom) {
      const p = prenom ? prenom[0].toUpperCase() : ''
      const n = nom ? nom[0].toUpperCase() : ''
      return `${p}${n}`
    }
  }
}
</script>



<style scoped>
/* Ajoute ici du style personnalisé si nécessaire */
</style>
